export const locale = {
	lang: 'en',
	data: {
		general: {
			pageNotFound: 'Page not found',
			unauthorized: 'You are unauthorized',
			spinnerMessage: 'Paging loading',
			loaderMessage: 'Loading ...',
			save: 'Save',
			update: 'Update',
			requiredFields: 'Required fields',
			cancel: 'Cancel',
			search: 'Search',
			reset: 'Reset',
		},
		devices: {
			title: 'Devices',
			confirmDisable: 'Do you want to disable the device?',
			confirmEnable: 'Do you want to enable the device?',
			enabled: 'Enabled',
			disabled: 'Disabled',
			confirmDelete: 'Do you want to delete this device?',
			new: 'Create a new device',
			edit: 'Edit device',
			position: 'Position',
			uploadFromCsv: 'Upload devices from CSV file',
			uploadDevices: 'Upload',
			downloadExample: 'Download an example CSV file',
			downloadDevices:'Download CSV',
			selectCsv: 'Select a CSV file',
			select_location: 'Select a location',
			success: {
				confirmDisable: 'Device disabled successfully',
				confirmEnable: 'Device enabled successfully',
				confirmDelete: 'Device deleted successfully',
				create: 'Device created successfully',
				update: 'Device updated successfully',
				upload: 'Devices uploaded successfully',
			},
			error: {
				devices: 'Unable to retrieve the list of devices',
				device: 'Unable to retrieve the device',
				locations: 'Unable to retrieve the list of locations',
				confirmDisable: 'Unable to disable the device',
				confirmEnable: 'Unable to enable the device',
				confirmDelete: 'An error occurred while deleting the device',
				create: 'Unable to create the device',
				update: 'Unable to update the device',
				unableRead: 'Unable to read the file',
				unableReadCsv: 'Unable to read the CSV file',
				upload: 'An error occurred during CSV file upload',
				deviceExist:'One or more devices already exist',
				download:'An error occurred while downloading the CSV'
			},
		},
		monitoring: {
			title: 'Monitoring',
			detail: 'Detail',
			confirmDisable: 'Do you want to disable device tracking?',
			confirmEnable: 'Do you want to enable device monitoring?',
			count: 'Total devices',
			online: 'Online devices',
			offline: 'Offline devices',
			pending:'Pending devices',
			findStatus: 'Find status',
			allStatus: 'All statuses',
			error: {
				confirmDisable: 'The device could not be disabled',
				confirmEnable: 'The device could not be enabled',
				counters: 'The monitoring values ​​could not be retrieved',
				allFields: 'Make sure you have filled in the date and status',
				confirmCSV:'The CSV could not be downloaded'
			},
			success: {
				confirmDisable: 'Device successfully disabled',
				confirmEnable: 'Device successfully enabled',
				confirmCSV:'CSV file downloaded successfully'
			},
			table: {
				timeline: 'Days the device connected',
				log: 'Log device by status',
			}
		},
		users: {
			title: 'Users',
			new: 'Create new user',
			edit: 'Edit user',
			confirmDelete: 'Do you want to delete this user',
			success: {
				create: 'User successfully created',
				update: 'User updated successfully',
				confirmDelete: 'User successfully deleted',
			},
			error: {
				users: 'Unable to retrieve the user list',
				user: 'Unable to retrieve the user',
				create: 'Error creating user',
				update: 'Error updating user',
				confirmDelete: 'Error deleting user',
			}
		},
		vpn: {
			title: 'VPN Management',
			new: 'Create new VPN',
			edit: 'Edit VPN',
			confirmDelete: 'Do you want to delete this VPN',
			confirmDisable: 'Do you want to disable the VPN?',
			confirmEnable: 'Do you want to enable the VPN',
			enabled: 'Enabled',
			disabled: 'Disabled',
			subnet:'Subnet',
			ip:'IP',
			ipTip: 'Press enter to confirm entering the IP address',
			success: {
				create: 'VPN created successfully',
				update: 'VPN updated successfully',
				confirmDelete: 'VPN successfully deleted',
				confirmDisable: 'VPN device successfully disabled',
				confirmEnable: 'VPN device successfully enabled',
			},
			error: {
				subnet: 'Subnet format not valid',
				ip: 'IP format not valid',
				vpn: 'The list of VPN devices could not be retrieved',
				create: 'Error creating VPN',
				update: 'Error updating VPN',
				confirmDelete: 'Error deleting VPN',
				confirmDisable: 'VPN management could not be disabled',
				confirmEnable: 'VPN management could not be enabled',
				data: "Check the data entered. The IP format is invalid or the name field is empty",
			}
		},
		table: {
			noData: 'No data available',
			uuid: 'UUID',
			MAC: 'MAC Address',
			name: 'Name',
			nasid: 'Fractional',
			ip: 'IP',
			last_seen: 'Last seen',
			last_seen_nasid: 'Last seen nasid',
			last_seen_location: 'Last seen location',
			location: 'Location',
			status: 'Status',
			monitoring: 'Monitoring',
			enabled: 'Enabled',
			disabled: 'Disabled',
			actions: 'Actions',
			edit: 'Edit',
			show: 'Show',
			delete: 'Delete',
			date: 'Date',
			log_message: 'Log message',
			first_name: 'First name',
			last_name: 'Last name',
			created_at: 'Creation date',
			role: 'Role',
			password: 'Password',
			email: 'Email',
			vpn: 'VPN',
			select_role:'Select role',
		},
		status:{
			CLOSED: 'No connection state at all.',
			LISTEN: 'Waiting for a connection request from any remote TCP and port.',
			SYN_SENT: 'Waiting for a matching connection request after having sent a connection request.',
			SYN_RECEIVED: 'Waiting for a confirming connection request acknowledgment after having both received and sent a connection request.',
			ESTABLISHED: 'An open connection, data received can be delivered to the user.',
			CLOSE_WAIT: 'Waiting for a connection termination request from the local user.',
			FIN_WAIT_1: 'Waiting for a connection termination request from the remote TCP, or an acknowledgment of the connection termination request previously sent.',
			CLOSING: 'Waiting for a connection termination request acknowledgment from the remote TCP<',
			LAST_ACK: 'Waiting for an acknowledgment of the connection termination request previously sent to the remote TCP (which had not yet been acknowledged when the socket was closed)',
			FIN_WAIT_2: 'Waiting for a connection termination request from the remote TCP.',
			TIME_WAIT: 'Waiting for enough time to pass to be sure the remote TCP received the acknowledgment of its connection termination request.',
		}
	}
}